<template>
  <b-container fluid>
    <!-- Modal Description -->
    <b-modal v-model="modalDesc.show" hide-footer title="Description">
      {{ modalDesc.data || '-' }}
    </b-modal>

    <!-- Tab -->
    <b-row>
      <b-col lg="12">
        <iq-card body-class="p-0">
          <template v-slot:body>
            <div class="iq-edit-list">
              <tab-nav :pills="true" class="iq-edit-profile d-flex">
                <tab-nav-items
                  class="col-md-3 p-0"
                  :active="true"
                  href="#equipment-category"
                  title="Equipment Category"
                  @click="tabSelected = 'equipment-category'"
                />
                <tab-nav-items
                  class="col-md-3 p-0"
                  :active="false"
                  href="#master-equipment"
                  title="Master Equipment"
                  @click="tabSelected = 'master-equipment'"
                />
                <tab-nav-items
                  class="col-md-3 p-0"
                  :active="false"
                  href="#jobClass"
                  title="Job Class"
                />
                <tab-nav-items
                  class="col-md-3 p-0"
                  :active="false"
                  href="#job"
                  title="Job Type / Index"
                />
              </tab-nav>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- End Tab -->
    <div id="pills-tabContent-2" class="tab-content">
      <!-- Ship Particular -->
      <tab-content-item :active="true" id="equipment-category">
        <template v-if="tabSelected == 'equipment-category'">
          <MasterEquipmentCategory />
        </template>
      </tab-content-item>
      <!-- End Ship Particular -->
      <!-- Component Parts -->
      <tab-content-item :active="false" id="master-equipment">
        <template v-if="tabSelected == 'master-equipment'">
          <MasterEquipment />
        </template>
      </tab-content-item>
      <!-- End Component Parts -->
      <!-- Job Class -->
      <tab-content-item :active="false" id="jobClass">
        <b-row>
          <b-col sm="8">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title text-primary">
                  <strong>Job Class Data</strong>
                </h4>
              </template>
              <template v-slot:body>
                <div class="d-flex mb-3">
                  <b-form-input
                    v-model="jobClass.params.search"
                    @input="debouncedJobClassSearch"
                    @keypress.enter="searchJobClass"
                    id="fleet_name"
                    style="width: 200px"
                    type="text"
                    placeholder="Search..."
                  ></b-form-input>
                </div>
                <b-row>
                  <b-col cols="12">
                    <div class="table-responsive">
                      <table class="table mb-0 table-striped table-hover">
                        <thead class="thead-light text-center">
                          <tr>
                            <th class="text-truncate text-left">No.</th>
                            <th class="text-truncate text-left">
                              Job Class Code
                            </th>
                            <th class="text-truncate text-left">Job Class</th>
                            <th class="text-truncate text-left">Description</th>
                            <th class="text-truncate text-center">Status</th>
                            <th class="text-truncate text-left">Action</th>
                          </tr>
                        </thead>
                        <tbody v-if="jobClass.data && jobClass.data.length > 0">
                          <tr v-for="(each, i) in jobClass.data" :key="i">
                            <td class="text-truncate">
                              {{ getOverallIndex(i, 'jobClass') }}
                            </td>
                            <td class="text-truncate">
                              {{ each.jobClassCode }}
                            </td>
                            <td class="text-truncate">{{ each.jobClass }}</td>
                            <td class="text-truncate">
                              <button
                                class="btn btn-sm btn-outline-primary"
                                @click="
                                  () => {
                                    modalDesc.show = true
                                    modalDesc.data = each.description
                                  }
                                "
                              >
                                Description
                              </button>
                            </td>
                            <td class="text-truncate text-center">
                              <b-badge
                                :variant="each.active ? 'primary' : 'danger'"
                              >
                                {{ each.active ? 'Active' : 'Inactive' }}
                              </b-badge>
                            </td>
                            <td class="text-truncate">
                              <span
                                class="text-info mr-1 cursor-pointer mr-2"
                                @click="initFormJobClass(each)"
                              >
                                <i class="fa fa-edit" />
                              </span>
                              <span
                                class="text-danger cursor-pointer"
                                @click="onDeleteJobClass(each)"
                              >
                                <i class="fa fa-trash" />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="8">No Data</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                  <b-col
                    class="mt-4"
                    v-if="jobClass.data && jobClass.data.length > 0"
                  >
                    <b-pagination
                      v-model="jobClass.meta.currentPage"
                      :total-rows="jobClass.meta.total"
                      @change="getJobClassList"
                      :per-page="jobClass.meta.perPage"
                      first-number
                      align="center"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </template>
            </iq-card>
          </b-col>
          <b-col sm="4">
            <iq-card
              :class="{
                'border border-danger shadow-lg': jobClass.editMode,
              }"
            >
              <template v-slot:headerTitle>
                <h4 class="card-title text-primary">
                  <strong>
                    {{ jobClass.editMode ? 'Edit' : 'Add' }} Job Class
                  </strong>
                </h4>
              </template>
              <template v-slot:body>
                <b-form
                  @submit.prevent="saveJobClass()"
                  @reset.prevent="initFormJobClass()"
                >
                  <b-form-group
                    label="Job Class Code *"
                    label-for="project_location"
                  >
                    <b-form-input
                      v-model="jobClass.form.jobClassCode"
                      id="Power Name"
                      type="text"
                      placeholder="Job Class Code"
                      maxlength="30"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Job Class *" label-for="project_location">
                    <b-form-input
                      v-model="jobClass.form.jobClass"
                      id="Power Name"
                      type="text"
                      placeholder="Job Class"
                      maxlength="30"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="Description" label="Description">
                    <tinymce
                      id="d1"
                      v-model="jobClass.form.description"
                    ></tinymce>
                  </b-form-group>
                  <b-form-group label="Status" label-for="technical_module">
                    <b-form-checkbox
                      v-model="jobClass.form.active"
                      name="check-button"
                      switch
                      inline
                    >
                      <template v-if="jobType.form.active === false">
                        Inactive
                      </template>
                      <template v-else>Active</template>
                    </b-form-checkbox>
                  </b-form-group>
                  <hr />
                  <b-form-group class="text-right">
                    <b-button type="submit" variant="primary">
                      <span>{{ jobClass.editMode ? 'Save' : 'Add' }}</span>
                    </b-button>
                    <b-button
                      type="reset"
                      variant="danger"
                      class="iq-bg-danger ml-3"
                    >
                      Cancel
                    </b-button>
                  </b-form-group>
                </b-form>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </tab-content-item>
      <!-- End Job Class -->
      <!-- Job Type -->
      <tab-content-item :active="false" id="job">
        <b-row>
          <b-col sm="8">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title text-primary">
                  <strong>Job Type / Job Index Data</strong>
                </h4>
              </template>
              <template v-slot:body>
                <div class="d-flex mb-3">
                  <b-form-input
                    v-model="jobType.params.search"
                    @input="debouncedJobTypeSearch"
                    @keypress.enter="searchJobType"
                    id="fleet_name"
                    style="width: 200px"
                    type="text"
                    placeholder="Search..."
                  ></b-form-input>
                </div>
                <b-row>
                  <b-col cols="12">
                    <div class="table-responsive">
                      <table class="table mb-0 table-striped table-hover">
                        <thead class="thead-light text-center">
                          <tr>
                            <th class="text-truncate text-left">No.</th>
                            <th class="text-truncate text-left">
                              Job Type Code
                            </th>
                            <th class="text-truncate text-left">
                              Job Type / Job Index
                            </th>
                            <th class="text-truncate text-left">Description</th>
                            <th class="text-truncate text-left">Status</th>
                            <th class="text-truncate text-left">Action</th>
                          </tr>
                        </thead>
                        <tbody v-if="jobType.data && jobType.data.length > 0">
                          <tr v-for="(each, i) in jobType.data" :key="i">
                            <td class="text-truncate">
                              {{ getOverallIndex(i, 'jobType') }}
                            </td>
                            <td class="text-truncate">
                              {{ each.jobTypeCode }}
                            </td>
                            <td class="text-truncate">
                              {{ each.jobTypeIndex }}
                            </td>
                            <td class="text-truncate">
                              <button
                                class="btn btn-sm btn-outline-primary"
                                @click="
                                  () => {
                                    modalDesc.show = true
                                    modalDesc.data = each.description
                                  }
                                "
                              >
                                Description
                              </button>
                            </td>
                            <td class="text-truncate">
                              <b-badge
                                :variant="each.active ? 'primary' : 'danger'"
                              >
                                {{ each.active ? 'Active' : 'Inactive' }}
                              </b-badge>
                            </td>
                            <td class="text-truncate">
                              <span
                                class="text-info mr-1 cursor-pointer"
                                @click="initFormJobType(each)"
                              >
                                <i class="fa fa-edit" />
                              </span>
                              <span
                                class="text-danger cursor-pointer"
                                @click="onDeleteJobType(each)"
                              >
                                <i class="fa fa-trash" />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="8">No Data</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                  <b-col
                    class="mt-4"
                    v-if="jobType.data && jobType.data.length > 0"
                  >
                    <b-pagination
                      v-model="jobType.meta.currentPage"
                      :total-rows="jobType.meta.total"
                      @change="getJobTypeList"
                      :per-page="jobType.meta.perPage"
                      first-number
                      align="center"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </template>
            </iq-card>
          </b-col>
          <b-col sm="4">
            <iq-card
              :class="{
                'border border-danger shadow-lg': jobType.editMode,
              }"
            >
              <template v-slot:headerTitle>
                <h4 class="card-title text-primary">
                  <strong>
                    {{ jobType.editMode ? 'Edit' : 'Add' }} Job Type / Job Index
                  </strong>
                </h4>
              </template>
              <template v-slot:body>
                <b-form
                  @submit.prevent="saveJobType()"
                  @reset.prevent="initFormJobType()"
                >
                  <b-form-group
                    label="Job Type Code *"
                    label-for="project_location"
                  >
                    <b-form-input
                      v-model="jobType.form.jobTypeCode"
                      id="Power Name"
                      type="text"
                      placeholder="Job Type Code"
                      maxlength="30"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Job Type / Job Index *"
                    label-for="project_location"
                  >
                    <b-form-input
                      v-model="jobType.form.jobTypeIndex"
                      id="Power Name"
                      type="text"
                      placeholder="Job Type"
                      maxlength="30"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="Description" label="Description">
                    <b-form-textarea
                      id="textarea"
                      v-model="jobType.form.description"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group label="Status" label-for="technical_module">
                    <b-form-checkbox
                      v-model="jobType.form.active"
                      name="check-button"
                      switch
                      inline
                    >
                      <template v-if="jobType.form.status === false">
                        Inactive
                      </template>
                      <template v-else>Active</template>
                    </b-form-checkbox>
                  </b-form-group>
                  <hr />
                  <b-form-group class="text-right">
                    <b-button type="submit" variant="primary">
                      <span>{{ jobType.editMode ? 'Save' : 'Add' }}</span>
                    </b-button>
                    <b-button
                      type="reset"
                      variant="danger"
                      class="iq-bg-danger ml-3"
                    >
                      Cancel
                    </b-button>
                  </b-form-group>
                </b-form>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </tab-content-item>
      <!-- End Job Type -->
    </div>
  </b-container>
</template>

<script>
import debounce from 'lodash/debounce'
import { maintenanceActions, fleetsActions } from '@src/Utils/helper'
import MasterEquipmentCategory from './Components/MaintenanceEquipmentNew/MasterEquipmentCategory.vue'
import MasterEquipment from './Components/MaintenanceEquipmentNew/MasterEquipment.vue'

export default {
  name: 'MaintenanceMasterEquipmentNew',
  components: {
    MasterEquipmentCategory,
    MasterEquipment,
  },
  data() {
    return {
      modalDesc: {
        data: null,
        show: false,
      },
      debouncedJobTypeSearch: null,
      debouncedJobClassSearch: null,
      tabSelected: 'equipment-category',
      rows: 100,
      perPage: 1,
      currentPage: 5,
      tinyOptions: {
        height: 500,
      },
      loading_export_structure: false,
      form_structure_edit_mode: false,
      noComponent: false,
      status: true,
      structureParent: [],
      nestableItems: [
        {
          id: 0,
          text: 'Acocommodation & Hull',
          children: [
            {
              id: 60,
              text: 'Tanks',
            },
          ],
        },
        {
          id: 1,
          text: 'Deck Equipment & Outfitting',
          children: [
            {
              text: 'Mooring Equipment',
              selected: true,
            },
            {
              text: 'Propeller',
              selected: true,
            },
            {
              text: 'Winch & Windlass',
              selected: true,
            },
          ],
        },
        {
          id: 2,
          text: 'Electrical Components & Parts',
        },
        {
          id: 3,
          text: 'Engine & Other Machinery',
          children: [
            {
              text: 'Gear Box',
              selected: true,
            },
            {
              text: 'Generator # Auxiliary Engine',
              selected: true,
            },
            {
              text: 'Generator Emergency',
              selected: true,
            },
          ],
        },
        {
          id: 4,
          text: 'Machinery Equipment',
          children: [
            {
              text: 'Main Engine',
              selected: true,
            },
          ],
        },
        {
          id: 5,
          text: 'Fire & Safety Equipment',
          children: [
            {
              text: 'Safety Equipment',
              selected: true,
            },
          ],
        },
        {
          id: 6,
          text: 'Navigation & Communication Equipment',
          children: [
            {
              text: 'Radio EQ',
              selected: true,
            },
          ],
        },
        {
          id: 7,
          text: 'Pipes & Fitting',
        },
        {
          id: 8,
          text: 'Pumps',
        },
      ],
      selectedFleetCategory: 'tugboat',
      fleetCategory: [
        {
          text: 'Tug Boat',
          color: 'success',
          value: 'tugboat',
        },
        {
          text: 'Barge',
          color: 'warning',
          value: 'barge',
        },
        {
          text: 'Mother Vessel',
          color: 'primary',
          value: 'mother_vessel',
        },
        {
          text: 'Heavy Equipment',
          color: 'primary',
          value: 'heavy_equipment',
        },
        {
          text: 'Pusher Tug',
          color: 'primary',
          value: 'pusher_tug',
        },
        {
          text: 'Pusher Barge',
          color: 'primary',
          value: 'pusher_barge',
        },
      ],
      typeFleet: [],
      jobType: {
        editMode: false,
        params: {
          search: '',
          perPage: 20,
          page: 1,
          export: true,
        },
        data: [],
        form: {
          jobTypeCode: '',
          jobTypeIndex: '',
          description: '',
          active: true,
        },
        detailData: null,
        meta: {
          perPage: 0,
          currentPage: 0,
          total: 0,
          totalPage: 0,
        },
      },
      jobClass: {
        editMode: false,
        params: {
          search: '',
          perPage: 20,
          page: 1,
          export: true,
        },
        data: [],
        form: {
          jobClassCode: '',
          jobClass: '',
          description: '',
          active: true,
        },
        detailData: null,
        meta: {
          perPage: 0,
          currentPage: 0,
          total: 0,
          totalPage: 0,
        },
      },
    }
  },
  mounted() {
    this.getJobTypeList()
    this.getJobClassList()
  },
  created() {
    // Create debounced search functions
    this.debouncedJobTypeSearch = debounce(() => {
      this.searchJobType()
    }, 1000)

    this.debouncedJobClassSearch = debounce(() => {
      this.searchJobClass()
    }, 1000)
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    searchJobType() {
      this.jobType.params.page = 1
      this.getJobTypeList(1)
    },
    searchJobClass() {
      this.jobClass.params.page = 1
      this.getJobClassList(1)
    },
    async getJobTypeList(page) {
      this.jobType.params.page = page || 1
      this.jobType.data = []
      const res = await this.getJobType(this.jobType.params)

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.jobType.data = res.data.data
          this.jobType.meta.perPage = res.data.perPage
          this.jobType.meta.currentPage = res.data.currentPage
          this.jobType.meta.total = res.data.total
          this.jobType.meta.totalPage = res.data.totalPage
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async getJobClassList(page) {
      this.jobClass.params.page = page || 1
      this.jobClass.data = []
      const res = await this.getJobClass(this.jobClass.params)

      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.jobClass.data = res.data.data
          this.jobClass.meta.perPage = res.data.perPage
          this.jobClass.meta.currentPage = res.data.currentPage
          this.jobClass.meta.total = res.data.total
          this.jobClass.meta.totalPage = res.data.totalPage
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    initFormJobType(data) {
      if (data) {
        this.jobType.editMode = true
        this.jobType.detailData = data
      } else {
        this.jobType.detailData = null
        this.jobType.editMode = false
      }
      this.jobType.form = {
        jobTypeCode: this.jobType.editMode ? data.jobTypeCode : '',
        jobTypeIndex: this.jobType.editMode ? data.jobTypeIndex : '',
        description: this.jobType.editMode ? data.description : '',
        active: this.jobType.editMode ? data.active : true,
      }
    },

    initFormJobClass(data) {
      if (data) {
        this.jobClass.editMode = true
        this.jobClass.detailData = data
      } else {
        this.jobClass.detailData = null
        this.jobClass.editMode = false
      }
      this.jobClass.form = {
        jobClassCode: this.jobClass.editMode ? data.jobClassCode : '',
        jobClass: this.jobClass.editMode ? data.jobClass : '',
        description: this.jobClass.editMode ? data.description : '',
        active: this.jobClass.editMode ? data.active : true,
      }
    },

    async saveJobType() {
      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading()
        },
      })

      if (this.jobType.editMode) {
        const res = await this.updateJobType({
          id: this.jobType.detailData.id,
          data: this.jobType.form,
        })
        if (res.status == 'success') {
          this.$swal('Update Job Type Success!', res.data.message, 'success')
          this.initFormJobType()
          this.getJobTypeList()
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const res = await this.createJobType(this.jobType.form)
        if (res.status == 'success') {
          this.$swal('Add Job Type Success!', res.data.message, 'success')
          this.initFormJobType()
          this.getJobTypeList()
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    async saveJobClass() {
      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading()
        },
      })

      if (this.jobClass.editMode) {
        const res = await this.updateJobClass({
          id: this.jobClass.detailData.id,
          data: this.jobClass.form,
        })
        if (res.status == 'success') {
          this.$swal('Update Job Class Success!', res.data.message, 'success')
          this.initFormJobClass()
          this.getJobClassList()
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const res = await this.createJobClass(this.jobClass.form)
        if (res.status == 'success') {
          this.$swal('Add Job Class Success!', res.data.message, 'success')
          this.initFormJobClass()
          this.getJobClassList()
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },
    onDeleteJobType(dataVal) {
      this.$swal({
        title: 'Delete Job Type?',
        text: `Job Type ${dataVal.jobTypeCode} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteJobTypeById(dataVal.id)
          if (res.status != 'success') {
            if (res.data.message != null)
              this.$swal('Error', res.data.message, 'error')
            else
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
          } else {
            this.getJobTypeList()
            this.$swal(
              `Job Type  deleted!`,
              `Job Type  ${dataVal.jobTypeCode} successfully deleted`,
              'success'
            )
          }
        }
      })
    },

    onDeleteJobClass(dataVal) {
      this.$swal({
        title: 'Delete Job Class?',
        text: `Job Class ${dataVal.jobClassCode} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteJobClassById(dataVal.id)
          if (res.status != 'success') {
            if (res.data.message != null)
              this.$swal('Error', res.data.message, 'error')
            else
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
          } else {
            this.getJobClassList()
            this.$swal(
              `Job Class deleted!`,
              `Job Class ${dataVal.jobClassCode} successfully deleted`,
              'success'
            )
          }
        }
      })
    },

    getOverallIndex(index, type) {
      switch (type) {
        case 'jobType':
          return (
            this.jobType.meta.currentPage * this.jobType.meta.perPage -
            this.jobType.meta.perPage +
            index +
            1
          )
          break
        case 'jobClass':
          return (
            this.jobClass.meta.currentPage * this.jobClass.meta.perPage -
            this.jobClass.meta.perPage +
            index +
            1
          )
          break
        case 'masterEquipment':
          return (
            this.masterEquipment.meta.currentPage *
              this.masterEquipment.meta.perPage -
            this.masterEquipment.meta.perPage +
            index +
            1
          )
          break

        default:
          break
      }
    },
  },
}
</script>

<style scoped>
.text-sm {
  font-size: small;
}
.item-nestable {
  border-radius: 8px;
  background: #f9fafb;
  color: gray !important;
}
</style>
